import { Component, Input } from '@angular/core';
import { CustomerBillingInvoiceModel } from '../customer-billing-invoice.model';
import { CustomerBillingHelperService } from '@fi-app/customer-billing/customer-billing-helper.service';
import { CustomerBillingInvoiceDetailModel } from '@fi-app/customer-billing/customer-billing-invoice/customer-billing-invoice-detail.model';
import { getPriceWithSeprator } from '@fi-shared/utils/get-price-with-separator';
import { isDefined } from '@fi-shared/utils';

@Component({
    selector: 'fi-customer-billing-invoice-view-invoice',
    templateUrl: './customer-billing-invoice-view-invoice.component.html',
    styleUrls: ['./customer-billing-invoice-view-invoice.component.scss'],
    host: { class: 'fi-customer-billing-invoice-view-invoice' },
    standalone: false,
})
export class CustomerBillingInvoiceViewInvoiceComponent {
    constructor(private customerBillingHelperService: CustomerBillingHelperService) {}

    @Input() invoice: CustomerBillingInvoiceModel;

    getCurrencyName() {
        return this.customerBillingHelperService.getCurrencyName(this.invoice.CurrencyType);
    }

    getItemPrice(invoiceDetail: CustomerBillingInvoiceDetailModel) {
        if (!isDefined(invoiceDetail.ItemPrice)) return '';
        return getPriceWithSeprator(parseFloat(invoiceDetail.ItemPrice));
    }

    getTotalAmount(invoiceDetail: CustomerBillingInvoiceDetailModel) {
        return getPriceWithSeprator(this.customerBillingHelperService.getInvoiceDetailsTotalAmount(invoiceDetail));
    }

    getVATAmount() {
        return getPriceWithSeprator(
            this.customerBillingHelperService.getInvoiceVATAmount(this.invoice.InvoiceDetails, this.invoice.ChargeVAT),
        );
    }

    getTotalAmountExcVat() {
        return getPriceWithSeprator(
            this.customerBillingHelperService.getInvoiceTotalAmountExcVat(this.invoice.InvoiceDetails),
        );
    }

    getTotalAmountIncVat() {
        return getPriceWithSeprator(
            this.customerBillingHelperService.getInvoiceTotalAmountIncVat(
                this.invoice.InvoiceDetails,
                this.invoice.ChargeVAT,
            ),
        );
    }
}
